import { render, staticRenderFns } from "./SetBarChart.vue?vue&type=template&id=42bd4184&scoped=true"
import script from "./SetBarChart.vue?vue&type=script&lang=js"
export * from "./SetBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bd4184",
  null
  
)

export default component.exports